import Navbar from "./Navbar";
import NavButton from "./NavButton";
import { useState } from "react";
import AutocompleteCustom from "./AutoCompleteCustom";
import ColumnsUnidata from "./ColumnsUnidata";
import Cookie from './Cookies';
import Loading from "./Loading";
import { DataGrid } from '@mui/x-data-grid';
import ConnectionFinder from "../api/ConnectionFinder";
import { useGridApiRef } from '@mui/x-data-grid';
const UniData = () => {
    const apiRef = useGridApiRef();
    const [city, setCity] = useState("");
    const [cities, setCities] = useState([]);
    const [addresses, setAddresses] = useState([]);
    const [civics, setCivics] = useState([]);
    const [address, setAddress] = useState("");
    const [civic, setCivic] = useState("");
    const [loading, setLoading] = useState(false);
    const [rows, setRows] = useState([]);

    let headers = {
        "x-access-token": localStorage.getItem('token')
    }

    const getCities = async (value) => {
        setCities([])
        setAddress("")
        setAddresses([])
        setCivic("")
        setCivics([])
        if (value.target.value.length < 3)
            return
        const response = await ConnectionFinder.get("/research/unidata/city", {
            params: {
                name: value.target.value
            },
            headers
        })
        setCities(response.data.map((row) => row.Comune));
    }
    const setValue = (setState, value) => {
        setState(value);
    }
    const getAddresses = async (value) => {
        setAddress("")
        setAddresses([])
        setCivic("")
        setCivics([])
        if (value.target.value.length < 3)
            return
        const response = await ConnectionFinder.get("/research/unidata/address", {
            params: {
                name: value.target.value,
                city: city
            },
            headers
        })
        setAddresses(response.data.map((row) => row.Via));
    }
    const getCivics = async (value) => {
        setCivic("")
        setCivics([])
        const response = await ConnectionFinder.get("/research/unidata/civic", {
            params: {
                name: value.target.value,
                address: address,
                city: city
            },
            headers   
        })
        setCivics(response.data.map((row) => row.Civico));
    }
    const getResults = async () => {    
        setLoading(true)
        const response = await ConnectionFinder.get("/research/unidata/results",{
            params: {
                city,
                address,
                civic
            },
            headers
        })
        setRows(response.data)
        setLoading(false)
    }

    return (
        <div style={{ background: 'linear-gradient(347deg, rgba(243,17,98,0.927608543417367) 8%, rgba(41,44,59,1) 61%)', paddingBottom: '30px', minHeight: 'calc(100vh - 30px)' }}>
        <Navbar />
        <div className='titleBar'><h1 style={{ color: '#ff0f64', fontSize: '2rem', margin: 0, marginLeft: '10px'}}>Ricerca Unidata</h1></div>
        <div className='InputContainerOF'>
            <AutocompleteCustom suggestions={cities} value={city} setvalue={setCity} onTextChange={getCities} onSelect={(e)=> setValue(setCity,e.target.value)} label={"Citta"} id="Citta" className="AutoCompleteFibre" />
            <AutocompleteCustom suggestions={addresses} value={address} setvalue={setAddress} onTextChange={getAddresses} onSelect={(e)=> setValue(setAddress,e.target.value)} label="Indirizzo" id="IndirizzoFibre" className="AutoCompleteFibre" />
            <AutocompleteCustom suggestions={civics} value={civic} setvalue={setCivic} onTextChange={getCivics} onSelect={(e)=> setValue(setCivic,e.target.value)} label="Civico" id="Civico" className="AutoCompleteFibre" />
            <div className='btn' style={{ width: '85%' }} onClick={() => getResults()}>Cerca</div>
        </div>
        <NavButton text="Indietro" to="/home" />
        <p style={{ color: 'white', fontWeight: 'bold', fontSize: '40px', margin: '0', textAlign: 'center', marginBottom: '6px' }}>Risultati</p>
        {loading ? <Loading /> : <div className='grid' >
            <DataGrid
            rows={rows}
            column
            columns={ColumnsUnidata}
            apiRef={apiRef}
            getRowId={(row) => row.ID}
            />

        </div>}
        <Cookie />
        </div>
    );
}
export default UniData;